import styled from "styled-components";
import { calculateResponsiveSize } from "helpers/calculateResponsiveSize";
import { mediaMax } from "helpers/mediaQueries";
import { Link } from "gatsby";
import BGGradient from "icons/footer-gradient.svg";
import HouseLogoWhite from "icons/house-logo-white.svg";

export const Wrapper = styled.div`
  width: 100%;
  color: #fff;
`;

export const Copyright = styled.span`
  /* font-weight: 600; */
  font-size: ${calculateResponsiveSize(14)};
  line-height: 1.2;
  font-family: "proxima_nova_light", san-serif;
  white-space: pre-wrap;
  ${mediaMax("desktopSm")} {
    font-size: 12px;
  }
  ${mediaMax("tabletLandscape")} {
    margin: 24px 0;
  }
`;

export const LegalLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: ${calculateResponsiveSize(24)};
  font-family: "proxima_nova_semibold", san-serif;
  font-size: 12px;
  /* font-weight: 600; */
  letter-spacing: 1.8px;
  text-transform: uppercase;
  &:before {
    content: "";
    display: block;
    margin-right: ${calculateResponsiveSize(24)};
    width: ${calculateResponsiveSize(31)};
    height: ${calculateResponsiveSize(30)};
    background: url(${HouseLogoWhite}) no-repeat center;
    background-size: contain;
  }
  ${mediaMax("desktopSm")} {
    font-size: 11px;
    letter-spacing: 1.4px;
    &:before {
      margin-right: 15px;
      width: 31px;
      height: 30px;
    }
  }
  ${mediaMax("tablet")} {
    margin-right: 10px;
   }
`;

export const FooterNavLink = styled(Link)`
  display: flex;
  align-items: center;
  margin-right: ${calculateResponsiveSize(24)};
  font-family: "proxima_nova_semibold", san-serif;
  font-size: 12px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  ${mediaMax("desktopSm")} {
    font-size: 11px;
    letter-spacing: 1.4px;
  }
  ${mediaMax("tablet")} {
   margin-right: 10px;
  }
`;

export const Logos = styled.div`
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(24)};
  padding-bottom: ${calculateResponsiveSize(24)};
  ${mediaMax("desktopSm")} {
    gap: 24px;
    margin: 24px 0;
  }
`;

export const FooterIconLink = styled.a`
  display: flex;
  align-items: center;
`;

export const FooterIconImg = styled.img`
  display: block;
  height: ${calculateResponsiveSize(31)};
  width: auto;
  object-fit: contain;
  ${mediaMax("desktopSm")} {
    height: 24px;
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  &:last-child {
    border-top: ${calculateResponsiveSize(1)} solid #fff;
    padding-top: ${calculateResponsiveSize(24)};
  }
  ${mediaMax("desktopM")} {
    flex-direction: column;
  }
`;

export const FooterLinkWrap = styled.div`
  display: flex;
  align-items: center;

`;

export const CookieLink = styled.button`
  display: flex;
  align-items: center;
  font-family: "proxima_nova_semibold", san-serif;
  font-size: 12px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  color: #fff;
    position: static;
    background: none;
    appearance: none;
    border: none;
    padding: 0;
    cursor: pointer;

  ${mediaMax("desktopSm")} {
    font-size: 11px;
    letter-spacing: 1.4px;
  }
`;
